/**
 * Tab switching for bundle product metafield accordions.
 */
class BundleProductMetafieldTabs extends HTMLElement {
  /** @type {HTMLButtonElement[]} */
  #tabs = [];

  /** @type {HTMLElement[]} */
  #panels = [];

  /** @type {AbortController | null} */
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.#tabs = [...this.querySelectorAll('[role="tab"]')];
    this.#panels = [...this.querySelectorAll('[role="tabpanel"]')];

    if (!this.#tabs.length || !this.#panels.length) return;

    this.#tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.#activateTab(tab), { signal });
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }

  /**
   * @param {HTMLButtonElement} activeTab
   */
  #activateTab(activeTab) {
    const panelId = activeTab.getAttribute('aria-controls');
    if (!panelId) return;

    this.#tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('bundle-product-accordion__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.#panels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  }
}

if (!customElements.get('bundle-product-metafield-tabs')) {
  customElements.define('bundle-product-metafield-tabs', BundleProductMetafieldTabs);
}
